import { Tabs as BaseTabs } from '@base-ui/react/tabs';
import type { ReactNode } from 'react';

export type TabItem = {
  value: string;
  label: ReactNode;
  content: ReactNode;
};

export interface TabsProps {
  items: TabItem[];
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
}

export function Tabs({ items, defaultValue, value, onValueChange }: TabsProps) {
  const initialValue = defaultValue ?? items[0]?.value;

  return (
    <BaseTabs.Root
      className="ui-tabs"
      defaultValue={value === undefined ? initialValue : undefined}
      value={value}
      onValueChange={onValueChange}
    >
      <BaseTabs.List className="ui-tabs__list">
        {items.map((item) => (
          <BaseTabs.Tab key={item.value} className="ui-tabs__tab" value={item.value}>
            {item.label}
          </BaseTabs.Tab>
        ))}
      </BaseTabs.List>
      {items.map((item) => (
        <BaseTabs.Panel key={item.value} className="ui-tabs__panel" value={item.value}>
          {item.content}
        </BaseTabs.Panel>
      ))}
    </BaseTabs.Root>
  );
}
